import { Classes, Dialog, Spinner } from "@blueprintjs/core";
import { INTENT_PRIMARY } from '@blueprintjs/core/lib/esm/common/classes';
import { handleBooleanChange } from "@blueprintjs/docs-theme";
import * as React from "react";
import { loadingSpinnerContainer, loadingSpinnerStyle, keyEventsSpinnerStyle, keyEventsSpinnerContainer } from './../components/styles';

class LoadingSpinner extends React.PureComponent {

	state = {
		canOutsideClickClose: false,
		isOpen: true,
		styles: {}
	};

	handleOutsideClickChange = handleBooleanChange(val => this.setState({ canOutsideClickClose: val }));

	componentDidMount() {
		this.getStyles(this.props.type);
	}

	getStyles(type) {
		var result;
		if (type === 'panel') {
			result = {
				size: Spinner.SIZE_STANDARD,
				styleContainer: keyEventsSpinnerContainer,
				styleSpinner: keyEventsSpinnerStyle,
				className: 'panel-bkg',
			}
		} else {
			result = {
				size: Spinner.SIZE_LARGE,
				styleContainer: loadingSpinnerContainer,
				styleSpinner: loadingSpinnerStyle
			}
		}

		this.setState({ styles: result });
	}

	render() {
		return (
			<div className={this.state.styles.className}>
				<Dialog
					onClose={this.handleClose}
					{...this.state}
					usePortal={false}
					style={this.state.styles.styleContainer}
				>
					<div className={Classes.DIALOG_BODY}>
						<div style={this.state.styles.styleSpinner}>
							<Spinner
								className={INTENT_PRIMARY}
								size={this.state.styles.size} />
						</div>
					</div>
				</Dialog>
			</div>
		);
	}

	handleOpen = () => this.setState({ isOpen: true });
	handleClose = () => {
		this.setState({ isOpen: false });
	}
}

export default LoadingSpinner;
